import { motion } from "framer-motion";
import ParticleBackground from "../components/ParticleBackground";
import {
  Target,
  Eye,
  ShieldCheck,
  Users,
  Code2,
  Globe2,
  ArrowRight,
} from "lucide-react";
import { Link } from "react-router-dom";
 


function About() {
  return (

<section className="relative min-h-screen overflow-hidden bg-slate-950 px-4 py-24 text-white sm:px-6 lg:px-8">
  {/* BACKGROUND */}
  <div className="absolute inset-0 z-0">
    <ParticleBackground />
  </div>





      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="mx-auto max-w-4xl text-center"
        >
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-cyan-400 sm:text-sm sm:tracking-[0.3em]">
            About Eiffeltech
          </p>

          <h1 className="mt-4 text-3xl font-black tracking-tight sm:text-5xl md:text-7xl">
            Creating digital systems from powerful ideas
          </h1>

          <p className="mx-auto mt-5 max-w-3xl text-sm leading-7 text-slate-300 sm:mt-6 sm:text-lg sm:leading-8">
            Eiffeltech is a technology company focused on building modern,
            secure and practical digital solutions for businesses, schools,
            healthcare institutions and growing organizations.
          </p>
        </motion.div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:mt-16 sm:gap-8 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, x: -35 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            className="rounded-[1.5rem] border border-cyan-400/20 bg-slate-900/80 p-5 shadow-2xl backdrop-blur-xl sm:rounded-[2rem] sm:p-8"
          >
            <h2 className="text-2xl font-black sm:text-3xl">Who We Are</h2>

            <p className="mt-4 text-sm leading-7 text-slate-300 sm:mt-5 sm:text-base sm:leading-8">
              We design and develop websites, portals, dashboards, mobile-ready
              platforms, database systems and secure software tools that help
              organizations improve service delivery and manage information
              efficiently.
            </p>

            <p className="mt-4 text-sm leading-7 text-slate-300 sm:mt-5 sm:text-base sm:leading-8">
              Our approach combines clean design, reliable development,
              security-focused thinking and real-world problem solving.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 35 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            className="rounded-[1.5rem] border border-cyan-400/20 bg-cyan-400 p-5 text-slate-950 shadow-2xl sm:rounded-[2rem] sm:p-8"
          >
            <h2 className="text-2xl font-black sm:text-3xl">What We Build</h2>

            <div className="mt-5 grid grid-cols-1 gap-3 sm:mt-6 sm:grid-cols-2 sm:gap-4">
              <InfoItem icon={<Globe2 size={20} />} text="Websites" />
              <InfoItem icon={<Code2 size={20} />} text="Custom Systems" />
              <InfoItem icon={<ShieldCheck size={20} />} text="Secure Platforms" />
              <InfoItem icon={<Users size={20} />} text="User Dashboards" />
            </div>
          </motion.div>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-5 sm:mt-10 sm:gap-8 md:grid-cols-2">
          <ValueCard
            icon={<Eye />}
            title="Our Vision"
            text="To become a trusted technology partner for organizations that need modern, secure and intelligent digital solutions."
          />

          <ValueCard
            icon={<Target />}
            title="Our Mission"
            text="To design and deliver high-quality digital systems that solve real problems, improve productivity and support business growth."
          />
        </div>

        <div className="mt-5 grid grid-cols-1 gap-5 sm:mt-10 sm:gap-8 md:grid-cols-3">
          <MiniCard
            number="01"
            title="Modern Design"
            text="Clean, responsive and professional interfaces that create strong first impressions."
          />

          <MiniCard
            number="02"
            title="Reliable Development"
            text="Structured code, scalable architecture and practical functionality for real use."
          />

          <MiniCard
            number="03"
            title="Security Mindset"
            text="Authentication, permissions and data protection are considered from the start."
          />
        </div>

        <div className="mt-10 rounded-[1.5rem] border border-cyan-400/20 bg-slate-900/80 p-5 text-center shadow-2xl backdrop-blur-xl sm:mt-16 sm:rounded-[2rem] sm:p-8">
          <h2 className="text-2xl font-black sm:text-4xl">
            Ready to work with Eiffeltech?
          </h2>

          <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-slate-300 sm:mt-5 sm:text-base sm:leading-8">
            Whether you need a company website, a school portal, a healthcare
            system, a dashboard or a custom platform, Eiffeltech can help bring
            your idea to life.
          </p>

          <div className="mt-6 flex flex-col justify-center gap-3 sm:mt-8 sm:flex-row sm:gap-4">
            <Link
              to="/services"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-cyan-400 px-5 py-3 text-sm font-bold text-slate-950 hover:bg-cyan-300 sm:px-7 sm:py-4 sm:text-base"
            >
              View Services <ArrowRight size={18} />
            </Link>

            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-full border border-cyan-400 px-5 py-3 text-sm font-bold text-cyan-400 hover:bg-cyan-400 hover:text-slate-950 sm:px-7 sm:py-4 sm:text-base"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function InfoItem({ icon, text }) {
  return (
    <div className="flex items-center gap-3 rounded-2xl bg-slate-900/80 p-4 text-sm font-bold sm:text-base">
      <span className="shrink-0">{icon}</span>
      <span>{text}</span>
    </div>
  );
}

function ValueCard({ icon, title, text }) {
  return (


    
    <motion.div
      whileHover={{ y: -6 }}
      className="rounded-[1.5rem] border border-cyan-400/20 bg-slate-900/80 p-5 shadow-2xl backdrop-blur-xl bg-black/10 sm:rounded-[2rem] sm:p-8"
    >
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-cyan-400 text-slate-950 sm:mb-5 sm:h-16 sm:w-16 sm:rounded-3xl">
        {icon}
      </div>

      <h2 className="text-xl font-black sm:text-2xl">{title}</h2>

      <p className="mt-3 text-sm leading-7 text-slate-300 sm:mt-4 sm:text-base">
        {text}
      </p>
    </motion.div>
  );
}

function MiniCard({ number, title, text }) {
  return (
    <motion.div
      whileHover={{ y: -6 }}
      className="rounded-[1.5rem] border border-cyan-400/20 bg-slate-900/80 p-5 shadow-2xl backdrop-blur-xl sm:rounded-[2rem] sm:p-8"
    >
      <p className="text-3xl font-black text-cyan-400 sm:text-4xl">{number}</p>
      <h3 className="mt-3 text-lg font-black sm:mt-4 sm:text-xl">{title}</h3>
      <p className="mt-3 text-sm leading-7 text-slate-300 sm:text-base">
        {text}
      </p>
    </motion.div>
  );
}

export default About;
